<template>
  <v-autocomplete
    :name="name"
    :value="value"
    @input="emitInput"
    @change="emitChange"
    @focus="$emit('focus')"
    @blur="$emit('blur')"
    @keyup="$emit('keyup')"
    :error-messages="errorMessages"
    :disabled="disabled"
    :items="items"
    :item-value="itemValue"
    :item-text="itemText"
    :menu-props="{bottom: true, offsetY: true}"
    :class="elementClass"
    :multiple="multiple"
    :label="label"
    :filter="customFilter"
    solo
    append-icon
    ref="select">
    
    <template slot="item" slot-scope="props">
      <v-icon v-if="props.item[itemIcon]" class="mr-2" size="18px">{{props.item[itemIcon]}}</v-icon>
      {{props.item[itemText]}}
    </template>
    
    <template slot="append-outer">
      <v-btn v-if="iconButton"
        class="select-button modal-cta"
        text
        icon
        @click="openSelectMenu"
        :disabled="disabled">
        <v-icon>fas fa-caret-down</v-icon>
      </v-btn>
      <image-button v-else
          class="select-button"
          icon
          :disabled="disabled"
          @click="openSelectMenu"
          :image="coloredAssetUrls.dropdown"/>
    </template>
  </v-autocomplete>
</template>

<script>
import imageButton from "./ImageButton";

export default {
  name: "selectWithAutoCompleteField",
  components: { imageButton },
  props: {
    value: [String, Array, Number, Boolean],
    name: String,
    items: Array,
    itemValue: { type: String, default: "value" },
    itemText: { type: String, default: "text" },
    itemIcon: { type: String, default: "icon" },
    errorMessages: Array,
    disabled: Boolean,
    iconButton: { type: Boolean, default: false },
    multiple: { type: Boolean, default: false },
    label: String
  },
  methods: {
    openSelectMenu() {
      // todo - this isn't quite right!
      // If we click an option which is hovering over the input, the menu is stuck open...
      // note: onClick({}) is a weird hack required as of vue 2.2.8. This deserves research to remove
      this.$refs.select.onClick({});
    },
    emitChange(selectValue) {
      this.$emit("change", selectValue);
    },
    emitInput(selectValue) {
      this.$emit("input", selectValue);
    },
    customFilter(item, queryText) {
      let itemVal = "";
      // Components using SelectWithButton template have different values that they are filtering for. Performing the appropriate checks here.
      if (item.text)
        itemVal = item.text.toLowerCase();
      else if (item.name)
        itemVal = item.name.toLowerCase();
      else
        itemVal = item.procedure.toLowerCase();
      const queryVal = queryText.toLowerCase();

      for (var i = 0; i < queryVal.length; i++) {
        if (itemVal.charAt(i) != queryText.charAt(i))
          return false;
      }
      return true;
    }
  },
  computed: {
    elementClass() {
      let classes = [
        "select-input", 
        this.class, 
        this.iconButton && "icon-button"
      ].filter(v => v).join(" ");
      return classes;
    }
  }
};
</script>

